/**
 * Quick Add to Cart Action
 * Triggered by: arc:action:quickAddToCart
 */

export const runQuickAddToCart = async (data = {}) => {
    try {
        const { quantity = 1, properties = {}, variantId: providedVariantId } = data;
        
        let variantId = providedVariantId;

        // Dispatch loading start event
        window.dispatchEvent(new CustomEvent('cart:add_loading_start', { detail: { variantId, quantity } }));

        // Use Alpine cart store
        await Alpine.store('cart').add(variantId, quantity, properties);

        // Dispatch success event
        window.dispatchEvent(new CustomEvent('cart:item_added', { detail: { variantId, quantity } }));
        window.dispatchEvent(new CustomEvent('cart:add_loading_end'));

        return {
            success: true,
            message: 'Item added to cart successfully'
        };

    } catch (error) {
        console.error('Error in quick add to cart:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

export default runQuickAddToCart;
